
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/humanizer/embed",
      function () {
        return require("private-next-pages/humanizer/embed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/humanizer/embed"])
      });
    }
  